import i18n from "../../../shared/i18n";
import SalesService from "@/modules/sales/SalesService";
import _ from "lodash";
import EventBus from "@/plugins/event-bus";
import {ON_UNSOLD_LOT_PROPOSAL_ERROR} from "@/plugins/event-bus/event-bus-names";

let getDefaultTableData = () => {
  return {
    loading: false,
    tableSource: 'unsold-proposals',
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    toggleColumns: {
      fields: getDefaultFields(),
      requiredFields: ['stock_no', 'lot_no', 'title', 'suggestion', 'proposal_status', 'new_low', 'new_high',
        'new_start_price', 'new_reserve', 'comment'],
      defaultFields: ['stock_no', 'lot_no', 'title', 'suggestion', 'proposal_status', 'new_low', 'new_high',
        'new_start_price', 'new_reserve', 'comment']
    }
  }
};

let getDefaultFields = () => {
  return [
    {key: 'stock_no', label: i18n.t('Stock No'), tdClass: 'stock-no-col', isVisible: true},
    {key: 'lot_no', label: i18n.t('Lot'), tdClass: 'lot-no-col', isVisible: true},
    {key: 'title', label: i18n.t('Title'), tdClass: 'title-col', isVisible: true},
    {key: 'suggestion', label: i18n.t('Suggestion'), tdClass: 'suggestion-col', isVisible: true},
    {key: 'proposal_status', label: i18n.t('Proposal Status'), tdClass: 'proposal-status-col', isVisible: true},
    {key: 'new_low', label: i18n.t('New Low Estimate'), tdClass: 'new-low-col', isVisible: true},
    {key: 'new_high', label: i18n.t('New High Estimate'), tdClass: 'new-high-col', isVisible: true},
    {key: 'new_start_price', label: i18n.t('New Start Price'), tdClass: 'new-start-price-col', isVisible: true},
    {key: 'new_reserve', label: i18n.t('New Reserve'), tdClass: 'new-reserve-col', isVisible: true},
    {key: 'comment', label: i18n.t('Comment'), tdClass: 'comment-col', isVisible: true},
    {key: 'image', label: i18n.t('Image'), tdClass: 'img-holder'},
    {key: 'total_bids', label: i18n.t('No. of Bids'), tdClass: 'bids-col'},
    {key: 'total_commission_bids', label: i18n.t('No. of Commission Bids'), tdClass: ' com-bids-col'},
    {key: 'total_telephone_bids', label: i18n.t('No. of Telephone Bids'), tdClass: 'tel-bids-col'},
    {key: 'estimate', label: i18n.t('Estimate'), tdClass: 'estimate-col'},
    {key: 'start_price', label: i18n.t('Start Price'), tdClass: 'start-price-col'},
    {key: 'proposal_sent_at', label: i18n.t('Proposal Sent at'), tdClass: 'proposal-sent-at-col'},
    {key: 'proposal_sent_by', label: i18n.t('Proposal Sent by'), tdClass: 'proposal-sent-by-col'},
    {key: 'proposal_confirmed_at', label: i18n.t('Proposal Confirmed at'), tdClass: 'proposal-confirmed-at-col'},
    {key: 'proposal_confirmed_by', label: i18n.t('Proposal Confirmed by'), tdClass: 'proposal-confirmed-by-col'},
    {key: 'reserve', label: i18n.t('Reserve'), tdClass: 'reserve-col'},
    {key: 'reserve_type', label: i18n.t('Reserve Type'), tdClass: 'reserve-type-col'},
    {key: 'new_reserve_type', label: i18n.t('New Reserve Type'), tdClass: 'new-reserve-type-col'},
  ]
}


export default {
  namespaced: true,
  state: {
    tableData: getDefaultTableData(),
    unsoldProposalModal: {
      show: false,
      customer: null,
      auction: null
    },
    lotEditModal: {
      show: false,
      lot: null,
      lot_no: null,
      reservation_uuid: null
    },
    lotBulkEditModal: {
      show: false,
      reservation_uuids: []
    },
    suggestionOptions: [
      {key: i18n.t('Reoffer in a new auction'), value: 'reoffer'},
      {key: i18n.t('Return to the Seller'), value: 'return'},
      {key: i18n.t('Transfer to 3rd party'), value: 'transfer'}
    ],
    proposalStatusOptions: [
      {key: i18n.t('Draft'), value: 'draft'},
      {key: i18n.t('Suggestion Not Sent'), value: 'suggestion_not_sent'},
      {key: i18n.t('Waiting for Seller Confirmation'), value: 'waiting'},
      {key: i18n.t('Seller Confirmed'), value: 'seller_confirmed'}
    ],
    bulkEditFields: ['proposal_suggestion', 'proposal_status', 'new_reserve', 'new_low', 'new_high', 'new_start_price',
      'new_reserve_type']
  },
  actions: {
    async getTableData({commit, state, dispatch}) {
      commit('updateTableLoading', true);
      const response = await SalesService.getProposalOfUnsoldLots({
        auction_uuid: state.unsoldProposalModal.auction.uuid,
        customer_uuid: state.unsoldProposalModal.customer.customer_uuid,
      })
      commit('updateTableLoading', false);
      if (response.success) {
        commit('updateTableData', response.body.lots);
      } else {
        dispatch('hideUnsoldProposalModal')
        if (response.body.non_field_errors) {
          EventBus.$emit(ON_UNSOLD_LOT_PROPOSAL_ERROR, response.body.non_field_errors[0])
        } else if (response.toastError) {
          EventBus.$emit(ON_UNSOLD_LOT_PROPOSAL_ERROR, response.toastError)
        }
      }
      return response;
    },

    async updateToggleColumns({commit}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    async showUnsoldProposalModal({state}, {customer, auction}) {
      state.unsoldProposalModal.customer = customer;
      state.unsoldProposalModal.auction = auction;
      state.unsoldProposalModal.show = true;
    },
    async hideUnsoldProposalModal({state}) {
      state.unsoldProposalModal.customer = null;
      state.unsoldProposalModal.auction = null;
      state.unsoldProposalModal.show = false;
    },
    async showLotEditModal({state}, payload) {
      const {lot, lot_no, reservation_uuid} = payload
      state.lotEditModal.lot = _.cloneDeep(lot);
      state.lotEditModal.lot_no = lot_no;
      state.lotEditModal.reservation_uuid = reservation_uuid;
      state.lotEditModal.show = true;
    },
    async hideLotEditModal({state}) {
      state.lotEditModal.show = false;
      state.lotEditModal.lot = null;
      state.lotEditModal.lot_no = null;
      state.lotEditModal.reservation_uuid = null;
    },
    async showLotBulkEditModal({state}, payload) {
      state.lotBulkEditModal.show = true;
      state.lotBulkEditModal.reservation_uuids = payload
    },
    async hideLotBulkEditModal({state}) {
      state.lotBulkEditModal.show = false;
      state.lotBulkEditModal.reservation_uuids = []
    },
    async updateLotEditModal({commit}, payload) {
      await commit('updateLotEditModal', payload)
    },
    async updateTablePagination({state}, payload) {
      state.tableData.pagination = {...state.tableData.pagination, ...payload}
    },
    async updatePaginationPage({commit}, payload) {
      await commit('updatePaginationPage', payload);
    },
  },
  mutations: {
    updateTableLoading: (state, payload) => state.tableData.loading = payload,
    updateTableData: (state, payload) => state.tableData.rows = payload,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData.toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData.toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData.toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData.toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
    updateLotEditModal: (state, payload) => state.lotEditModal.lot = payload,
    updatePaginationPage: (state, payload) => state.tableData.pagination.page = payload,
  }
}
